<div class="bg-fraud-green-800 py-4 px-4 relative grow">
  <button class="absolute top-5 right-5 w-[16px] h-[16px] flex items-center justify-center" mat-dialog-close>
    <mat-icon class="!w-[16px] !h-[16px]" [svgIcon]="'close'"></mat-icon>
  </button>
  <div class="flex flex-col">
    <div class="flex items-center mb-[72px]">
      <span class="font-[Inter] text-[20px] leading-[1.3] text-white font-bold mr-[11px]">Deposit balance</span>
      <span class="inline-block w-[2px] h-[18px] bg-[#778F8F]"></span>
      <span class="ml-2 flex items-center">
        <span class="text-[#FFD900] text-[16px]">{{balance() | number:('1.2-2')}}</span>
        <mat-icon class="!w-3 !h-[11px] text-[#FFD900] ml-1" [svgIcon]="'tether'"></mat-icon>
      </span>
    </div>


    @if (depositAddress(); as depositAddress) {
      @if(paymentStep() === 'details' || paymentStep() === 'intro'){
        <div class="flex gap-[8px] mb-[10px]">
          <button
            class="outline-none w-full text-[11px] leading-[10px] font-semibold text-white bg-[#022D35] rounded-[6px] min-h-[28px] transition-all duration-300 ease-in">
            USDT TRC-20
          </button>
          <button class="pointer-events-none outline-none w-full text-[11px] leading-[10px] min-h-[28px] font-semibold text-[#A1C4C7] bg-white/[0.06]
          transition-all duration-300 ease-in
          rounded-[4px] hover:bg-white/10 hover:text-white">
            USDT ERC-20
          </button>
        </div>
      }
      @switch (paymentStep()){
        @case ('intro'){
          <div class="flex flex-col gap-4 items-center justify-center grow shrink-0 p-5 border border-dashed border-[rgba(255,255,255,0.15)] bg-[#022D35] rounded-[12px]">
            <div class="flex flex-col items-center gap-[3px]">
            <span class="text-center text-[10px] font-medium leading-[1.2] tracking-[0.6px] text-[#A1C4C7] uppercase">
              Minimum top-up
            </span>
              <span class="text-center text-[24px] font-bold leading-[29px] text-white">
              {{minBalance() | number:('1.2-2')}} USDT
            </span>
            </div>

            <div class="flex h-[19px] w-[18px] flex-col items-center">
              <div class="h-2.5 w-3 rounded-t-[6px] border-2 border-b-0 border-[rgba(255,255,255,0.8)]"></div>
              <div class="-mt-[1px] h-[11px] w-4 rounded-[2.5px] bg-[rgba(255,255,255,0.85)]"></div>
            </div>

            <p class="max-w-[180px] text-center text-[11px] font-500 leading-[13px] text-[#A1C4C7]">
              A smaller deposit is held until you top up to the minimum
            </p>
          </div>
        }
        @case ('details'){
          @if (heldBalance() > 0){
            <!--Payment progress bar-->
            <div class="flex w-full flex-col items-start gap-[10px] rounded-[12px] bg-[#022D35] p-[14px] mb-[10px]">
              <div class="flex w-full flex-row justify-between items-center gap-2">
            <span class="text-[12px] font-medium leading-[15px] text-white">
              Received {{heldBalance() | number:('1.2-2')}} USDT
            </span>
                <span class="text-[12px] font-medium leading-[15px] text-[#38CC8D]">
              {{ leftNeedDepositBalance() | number:('1.2-2')}} USDT to go
            </span>
              </div>

              <div class="h-[6px] w-full rounded-full bg-white/[0.14] overflow-hidden">
                <div class="h-full rounded-full bg-[#38CC8D]" [style]="'width:' +  percentHoldedBalance() + '%;'"></div>
              </div>

              <p class="w-full text-[10px] font-semibold leading-[1.2] text-[#A1C4C7]">
                Send the rest to the same address to credit your balance
              </p>
            </div>
          } @else {
            <div class="w-full bg-[#BF730F]/[0.16] flex flex-col items-center justify-center font-semibold text-[11px] text-[#F2B85C] rounded-[8px] px-[10px] py-1 min-h-[32px] mb-[10px]">
              Minimum top-up — {{minBalance() | number:('1.2-2')}} USDT
            </div>
          }
          <div class="flex items-center justify-between text-[12px] font-medium font-second text-white mb-[10px] p-[10px] rounded-[10px] bg-white/[0.06]">
            <span class="w-[205px] table-cell break-words leading-[1.25]">
              {{ depositAddress }}
            </span>
            <div class="w-[22px] h-[22px] rounded-[4px] flex flex-col items-center justify-center bg-white/[0.08] ml-[10px]">
              <app-copy-button
                [currentColor]="'text-white'"
                [value]="depositAddress"
                [size]="'small'"
              >
              </app-copy-button>
            </div>
          </div>
          <div
            class="max-w-[150px] w-[150px] h-[150px] flex flex-col justify-center items-center bg-white rounded-[7px] p-[8px] mb-[10px] mx-auto">
            @if (isGenerating()) {
              Generating QRCode...
            } @else {
              @if (qrCodeUrl(); as url) {
                <!--     Don`t use ngSrc     -->
                <img [src]="url" alt="Deposit address qr code" height="113" width="114">
              } @else {
                Ups... Something went wrong
              }
            }
          </div>
          <div class="flex text-[#BF730F] text-[10px] items-center gap-[6px] justify-center leading-[1.25] font-semibold">
            <mat-icon svgIcon="warning" class="!w-4 !h-4 text-[#BF730F]"></mat-icon>
            QR for USDT TRC-20 payment
          </div>
        }
        @case ('success'){
          <div class="flex flex-col gap-4 items-center justify-center grow shrink-0 p-5 border border-dashed border-[rgba(255,255,255,0.15)] bg-[#022D35] rounded-[12px]">
            <div class="size-[72px] rounded-full bg-[#218c59]/[0.18] flex items-center justify-center">
              <div class="size-14 rounded-full bg-[#218c59] shadow-[0_6px_14px_0_rgba(33,140,89,0.4)] flex items-center justify-center text-white text-[28px] font-bold leading-none">
                <mat-icon svgIcon="pricing-check-mark" class="!w-full !h-auto max-w-[32px] max-h-[28px] text-white mt-[6px]"></mat-icon>
              </div>
            </div>
            <span class="!text-[18px] leading-[1.85] font-bold text-white flex justify-center text-center items-center">
                Balance topped up
            </span>
          </div>
        }
      }
      @if(paymentStep() === 'success' || paymentStep() === 'intro'){
        <button
          (click)="paymentStep.set('details')"
          class="mt-[10px] min-h-[40px] flex w-full items-center justify-center rounded-lg bg-[#38CC8D] py-3 text-center text-[13px] font-semibold leading-[1.2] text-[#0F3D3B] transition-colors hover:bg-[#022D35] hover:text-white">
          Top up
        </button>
      }

    } @else {
      <app-deposit-address-missing></app-deposit-address-missing>
    }




    <!-- <div class="flex flex-col mb-[12px] pl-[10px] pt-[22px] pb-[10px]">
      <div class="flex items-center gap-2.5 mb-[3px] pr-[6px]">
        <span class="font-[Inter] break-all text-[16px] font-medium leading-[1.22] text-white">{{depositAddress()}}</span>
        <app-copy-button [currentColor]="'text-white'" class="h-[16px]" [value]="depositAddress() || ''" [size]="'big'"></app-copy-button>
      </div>

      <div class="flex items-center gap-[11px]">
        <div class="bg-white flex items-center justify-center p-2 rounded-[5px] w-32 h-32 shrink-0">
          @if (qrCodeUrl(); as url) {
            <img [src]="url" alt="Deposit address qr code" height="113" width="114">
          }
        </div>
        <div>
          <div class="flex items-center gap-1.5 mb-2">
            <mat-icon class="text-[#FFD900] text-[16px] !w-4 !h-4">warning</mat-icon>
            <span class="text-[#FFD900] text-[12px] italic leading-[1.3]">{{ 'pages.subscribed_wallet.wallet.text28' | translate }}</span>
          </div>
          <p class="text-[12px] !mb-0 pl-6 leading-[1.3] text-white" [innerHTML]="'dialog_balance.text5' | translate : { minBalance: (minBalance() | number:('1.2-2')) }"></p>
        </div>
      </div>
    </div>
    <div class="flex items-center mb-[18px]">
      <mat-icon class="!w-[27px] !h-[27px] !min-w-[27px] mr-2" svgIcon="round-attention"></mat-icon>
      <span class="text-[14px] leading-[1.3] text-white">{{ 'dialog_balance.text2' | translate }}</span>
    </div>
    <a target="_blank" [href]="linkWebVersion()" class="flex items-center justify-center rounded-[5px] border border-solid border-[#FFD900] text-[18px] font-medium leading-[1.17] min-h-[45px] w-full text-[#FFD900] hover:bg-[#FFD900] hover:text-[#234542]" mat-raised-button
      color="primary">
      {{ 'dialog_balance.button' | translate }}
    </a> -->
  </div>
</div>
